import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';

import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';


const InvoicingCustomerBalance = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});

  useEffect(() => {
        setPermission(FindModuleById(211)); 
console.log(permission);

    axios
      .post(
        "/customers-balances",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.customers);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
 

const CustomerNameCell = ({ renderedCellValue, row }) => {
  return (
    <a href={`/customer-balances-details/${row.original.id}`} className="">
      {renderedCellValue}
    </a>
  );
};

// ✅ Define PropTypes validation
CustomerNameCell.propTypes = {
  renderedCellValue: PropTypes.string.isRequired,
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

// ✅ Main table columns definition
const columns = [
  {
    header: 'Customer Name',
    accessorFn: (row) => row.company_name,
    Cell: CustomerNameCell, // ✅ Used separate component for cleaner code
  },
  {
    header: 'Total Sales',
    accessorFn: (row) => `${row.total_sale.toFixed(2)}${row.currency ? row.currency.symbol : ''}`,
  },
  {
    header: 'Credit note',
    accessorFn: (row) => `${row.credit_note_amount.toFixed(2)}${row.currency ? row.currency.symbol : ''}`,
  },
  {
    header: 'Paid Amount',
    accessorFn: (row) => `${row.paid_amount.toFixed(2)}${row.currency ? row.currency.symbol : ''}`,
  },
  {
    header: 'Open Amount',
    accessorFn: (row) => `${row.open_amount.toFixed(2)}${row.currency ? row.currency.symbol : ''}`,
  },
];

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Customers Balance</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">Customers Balance</li>
                  </ul>
                </div>
              
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table">
                  <div className="card-body">
                    <div className="table-responsive">
                    {permission && permission.list === 1 && ( 
                      <MaterialReactTable columns={columns} data={data} 
                      enableColumnOrdering
                   
                    />
                    )}
                    
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default InvoicingCustomerBalance;
